import { ChangeDetectionStrategy, Component, Input, SimpleChanges } from '@angular/core';
import { ProductListing } from '@df/catalog-ui/listing/product-listing';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ButtonStyleComponent } from '../../../common/buttons/button-style/button-style.component';
import { ProgressBarComponent } from '../../../common/progress-bar/progress-bar.component';
import { IProductDataV2 } from '@df/catalog/product/product';
import { Product } from '../../product/product.decorator';
import { UiComponent } from '@df/ui/ui.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'load-more',
    templateUrl: './load-more.html',
    styleUrls: ['./load-more.scss'],
    imports: [TranslationModule, ProgressBarComponent, ButtonStyleComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadMoreComponent extends UiComponent {
    @Input()
    listing?: ProductListing<Product<IProductDataV2>>;

    /**
     * Products the listing renders when it differs from its own limit (server render), so the
     * count and button match what the browser shows once the app takes over
     */
    @Input()
    serverLimit?: number;

    private listingSubscription?: Subscription;

    override ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
        if (changes['listing']) {
            this.listingSubscription?.unsubscribe();
            if (this.listing) {
                this.listingSubscription = this.listing.subscribe(() => this.detectChanges());
            }
        }
    }

    override ngOnDestroy(): void {
        super.ngOnDestroy();
        this.listingSubscription?.unsubscribe();
    }

    protected get visibleQty(): number {
        const visibleQty = this.listing?.visibleQty || 0;
        return this.serverLimit === undefined ? visibleQty : Math.min(visibleQty, this.serverLimit);
    }

    protected get totalQty(): number {
        return this.listing?.getTotal() || 0;
    }

    protected get hasMore(): boolean {
        return this.serverLimit === undefined ? this.listing?.hasMore || false : this.totalQty > this.serverLimit;
    }
}
